export default __webpack_public_path__ + "static/media/addy.2eb755ba.png";